var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgActivismPlay = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 21 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M19.273 10.294c1.275.78 1.275 2.632 0 3.412L4.013 23.04c-1.333.815-3.044-.144-3.044-1.707V2.668c0-1.562 1.71-2.52 3.043-1.706l15.26 9.333Z"
})));
export default SvgActivismPlay;